import palette from 'palette';
import styled from 'styled-components/macro';

export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const StyledSummary = styled.div`
  padding: 24px;
  margin: 24px;
  height: calc(100% - 48px);
  background-color: ${palette.white.w1};
`;

export const StyledTriggerContainer = styled.div`
  margin-bottom: 20px;
`;

export const StyledSort = styled.div`
  display: flex;
  justify-content: end;
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
`;
